import processInclude from "base/util";
import search from "./search/search";
import quickView from "base/product/quickView";
import wishlistHeart from "./product/wishlistHeart";

$(document).ready(() => {
    processInclude(search);
    processInclude(quickView);
    processInclude(wishlistHeart);

    if ($(window).width() > 992) {
        if ($(".search-field")[0].value !== null && $(".search-field")[0].value !== "") {
            $(".search-header.js-toggle-search").trigger("click");
        }
    }
});
